<template>
    <div class="server-authorization">
        <mc-operate-bar>
            <template slot="left">
                <div class="mc-search-bar">
                    <div class="mc-search-bar-input">
                        <el-input placeholder="输入授权站点" style="margin-right:10px" v-model="searchParmas.site"></el-input>
                        <el-input placeholder="输入授权方或服务方" v-model="searchParmas.serve"></el-input>
                    </div>
                    <el-button class="mc-search-bar-btn" type="primary" icon="el-icon-search" size="mini" @click="$_getTableList()"></el-button>
                    <el-button class="mc-search-bar-btn" type="danger" icon="el-icon-close" @click="$_reset()" size="mini"
                        v-if="searchParmas.site||searchParmas.serve"></el-button>
                </div>
            </template>
            <template slot="right">
                <el-button type="primary" @click="dialog.serve.methods.open()">新增授权</el-button>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0">
                    <!-- <template slot-scope="scope"> -->
                        <span>数据库</span>
                    <!-- </template> -->
                </el-table-column>
                <el-table-column :prop="tableOption.head[4].prop" :label="tableOption.head[4].label" :width="tableOption.head[4].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0"></span>
                        <span v-else-if="scope.row.status == 1">等待确认</span>
                        <span v-else-if="scope.row.status == 2">确认完成</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[5].prop" :label="tableOption.head[5].label" :width="tableOption.head[5].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 2 && scope.row.grantor_id == user_id">
                            <el-button size="mini" type="danger" @click="$_openCanel(scope.row)">取消授权</el-button>
                        </span>
                        <span v-else-if="scope.row.status == 1 && scope.row.grantee_id == user_id">
                            <el-button size="mini" type="primary" @click="$_openConfirm(scope.row)">确认授权</el-button>
                        </span>
                        <span v-else-if="scope.row.status == 1 && scope.row.grantor_id == user_id">
                            <el-button size="mini" type="danger" @click="$_openCanel(scope.row)">取消授权</el-button>
                        </span>
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="server-authorization-pager" @getList="$_getTableList"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.serve">
            <template slot="content">
                <mc-layout-row label-text="授权站点" :labelWidth="150" important>
                    <el-select style="width:100%" placeholder="请选择" v-model='selectData.site.value'>
                        <el-option v-for="item in selectData.site.list" :key="item.site_id" :label="item.site_name"
                            :value="item.site_id">
                        </el-option>
                    </el-select>
                </mc-layout-row>

                <mc-layout-row label-text="服务方" :labelWidth="150" important>
                    <el-select style="width:100%" :placeholder="!selectData.site.value?'请先选择授权站点':'请选择'" v-model='selectData.partner.value'
                        :disabled="!selectData.site.value">
                        <el-option v-for="item in selectData.partner.list" :key="item.partner_id" :label="item.partner_name"
                            :value="item.partner_id">
                        </el-option>
                    </el-select>
                </mc-layout-row>

                <mc-layout-row label-text="授权服务" :labelWidth="150" content-align-row="left" important>
                    <el-checkbox-group v-model="selectData.module.value">
                        <el-checkbox v-for="(item, index) in selectData.module.list" :key="index" :label="item.module_id">
                            {{ item.module_name }}
                        </el-checkbox>
                    </el-checkbox-group>
                </mc-layout-row>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.canel">
            <template slot="content">
                <mc-label icon="el-icon-error" error>取消授权后不可恢复，确定执行此操作吗？</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.confirm">
            <template slot="content">
                <mc-label icon="el-icon-info" info>确认授权后不可恢复，确定执行此操作吗？</mc-label>
            </template>
        </mc-dialog>

    </div>
</template>

<script>
    export default {
        name: "server-authorization",
        data() {
            return {
                user_id: '',
                searchParmas: {
                    site: '',
                    serve: ''
                },
                selectData: {
                    site: {
                        list: [],
                        value: [],
                    },
                    partner: {
                        list: [],
                        value: [],
                    },
                    module: {
                        list: [],
                        value: [],
                    }
                }, //选择下拉列表的数据
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: false,
                        label: "操作",
                        items: [{
                            label: "取消授权",
                            type: "danger",
                            size: 'mini',
                            click: (index, row) => {
                                this.dialog.canel.methods.open(row);
                            },
                        }, ],
                    },
                    head: [{
                            prop: "site_name",
                            label: "授权站点",
                            width: "",
                        },
                        {
                            prop: "grantor_name",
                            label: "授权方",
                            width: "",
                        },
                        {
                            prop: "grantee_name",
                            label: "服务方",
                            width: "",
                        },
                        {
                            prop: "create_at",
                            label: "授权服务",
                            width: "200",
                        },
                        {
                            prop: "status",
                            label: "授权状态",
                            width: "150",
                        },
                        {
                            prop: "status",
                            label: "操作",
                            width: "100"
                        },
                    ],
                    data: [],
                },
                dialog: {
                    serve: {
                        visible: false,
                        title: "新增授权",
                        style: {
                            showConfirm: true,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.serve.visible = true;
                                for (let i in this.selectData) {
                                    this.selectData[i].value = []
                                }
                            },
                            confirm: () => {
                                this.$_serve();
                            }
                        },
                        data: {
                            checked: false,
                        },
                    },
                    canel: {
                        visible: false,
                        title: "取消授权",
                        style: {
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.canel.data.row = item
                                this.dialog.canel.visible = true;
                            },
                            confirm: () => {
                                this.$_canel();
                            }
                        },
                        data: {
                            row: {},
                        },
                    },
                    confirm: {
                        visible: false,
                        title: "确认授权",
                        style: {
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.confirm.data.row = item
                                this.dialog.confirm.visible = true;
                            },
                            confirm: () => {
                                this.$_confirm();
                            }
                        },
                        data: {
                            row: {},
                        },
                    }
                },
            }
        },
        mounted() {
            this.$_getTableList();
            this.$_getSiteList();
            this.user_id = window.sessionStorage.id;
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    page: this.pager.page,
                    per_page: this.pager.per_page,
                    partner_name: this.searchParmas.serve,
                    site_name: this.searchParmas.site
                }
                let data = await this.$api.adminServerAuthorization.getList.getPendList.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.items;
                }
                this.tableOption.loading = false;
            },
            $_getSiteList: async function () {
                let params = {}
                let data = await this.$api.adminServerAuthorization.getList.getSiteList.call(this, params);
                if (data !== false) {
                    this.selectData.site.list = data.site;
                    this.selectData.partner.list = data.partner;
                    this.selectData.module.list = data.module;
                }
            },
            $_serve: async function () {
                let params = {
                    site_id: this.selectData.site.value,
                    grantee_id: this.selectData.partner.value,
                    delegation_module: this.$_handleRequestData(this.selectData.module.value),
                }
                let data = await this.$api.adminServerAuthorization.getList.grant.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    this.dialog.serve.visible = false;
                    this.$message.success('添加成功.');
                }
            },
            $_canel: async function () {
                let params = {
                    id: this.dialog.canel.data.row.id
                }
                let data = await this.$api.adminServerAuthorization.getList.canel.call(this, params);
                if (data !== false) {
                    this.dialog.canel.visible = false;
                    this.$_getTableList();
                    this.$message.success("取消成功.");
                }
            },
            $_confirm: async function () {
                let params = {
                    id: this.dialog.confirm.data.row.id
                }
                let data = await this.$api.adminServerAuthorization.getList.confirm.call(this, params);
                if (data !== false) {
                    this.dialog.confirm.visible = false;
                    this.$_getTableList();
                    this.$message.success("确认成功.");
                }
            },
            $_handleRequestData(arr) {
                let result = 0;
                arr.map(item => {
                    result += (item - 0);
                })
                return result + '';
            },
            $_reset() {
                this.searchParmas.site = '';
                this.searchParmas.serve = '';
                this.$_getTableList();
            },
            $_openCanel(row) {
                this.dialog.canel.methods.open(row);
            },
            $_openConfirm(row) {
                this.dialog.confirm.methods.open(row);
            }
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .server-authorization {
        .mc-search-bar {
            // width: 100%;
            height: 100%;
            display: flex;

            .mc-search-bar-input {
                margin-right: 10px;
                display: inline-flex;
            }

            .mc-search-bar-btn {
                height: 40px;
            }
        }

        .el-dialog {
            .require {
                color: red
            }

            .site-item {
                display: inline-flex;
                align-items: center;
                width: 100%;
                margin-bottom: 20px;

                label {
                    width: 100px;
                    text-align: right;
                }

                .site-input {
                    flex: 1;
                    padding-left: 10px;
                }
            }
        }
    }
</style>